import { useLoading } from '../contexts/LoadingContext'

export default function GlobalLoadingIndicator() {
  const { isLoading, loadingMessage } = useLoading()

  if (!isLoading) return null

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl p-6 flex flex-col items-center gap-4 min-w-[200px]">
        <div className="relative">
          <div className="w-12 h-12 border-4 border-primary-200 rounded-full"></div>
          <div className="absolute top-0 left-0 w-12 h-12 border-4 border-primary-600 rounded-full border-t-transparent animate-spin"></div>
        </div>
        {loadingMessage && (
          <p className="text-sm text-gray-600 text-center">{loadingMessage}</p>
        )}
      </div>
    </div>
  )
}
